import { Calculations } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/calculations';
import { panchang } from '../panchang.js';
import { istEpoch, istParts } from '../ist';
export class Kollavarsham {
    settings;
    constructor({ system = 'SuryaSiddhanta', latitude = 8.520929, longitude = 76.941200 } = {}) {

        this.settings = {
            system,
            latitude,
            longitude
        };
    }


    getSettings() {
        return this.settings;
    }


    setSystem(system) {
        this.settings.system = system;
    }


    setLatitude(latitude) {
        this.settings.latitude = latitude;
    }

    setLongitude(longitude) {
        this.settings.longitude = longitude;
    }


    fromGregorianDate(date: Date, hour = 7, minute = 30) {
        const calculations = new Calculations(this.settings);
        const panchangam = new panchang();
        // Anchor at hour:minute IST of the date's IST calendar day (was
        // host-local via moment().set) — the panchang is Kerala-time only.
        const p = istParts(date);
        const dateWithTime = new Date(istEpoch(p.year, p.month, p.day, hour, minute));
        const panCalc = panchangam.calculate(dateWithTime);
        // console.log(forPan);
        // console.log(dateWithTime);

        // if (date.getDate() === new Date().getDate() && new Date().getMonth() === date.getMonth()) {
        //     console.log('naksha name', calculations.fromGregorian(date).naksatraName);
        //     console.log('naksha', panCalc.Nakshatra);
        //     console.log('tithi', panCalc.Tithi);
        //     console.log('date', date);
        // }
        //    ;
        // return {
        //     kollavarsham: calculations.fromGregorian(date),
        //     panchang: panCalc
        // };

        return {
            kollavarsham: calculations.customCalculation(date),
            panchang: panCalc
        };
    }


}
